import { SettingsStorageBase } from 'web-core-src';

export interface ISettings {
    version: string;
    settingsStorage: SettingsStorageBase;
    init(): void;
    updateSettingsInStorage(): void;
    createPreImportBackup(): void;
    setDefaultValues(): void;
    translateDefaultValues(): void;
    setAppSettings(settingsJsonString: string): void;
    getAppSettings(): ISettings;
    getCurrentSettingsJSON(): string;
    loadSettingsFromStorage(): Promise<void>;
}
